import {Component, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from "@angular/router";
import {AuthTokenService} from '../../../shared/services/auth-token.service';
import {SurveyService} from "../surveys.service";
import {ReportListItemModel, ReportSummaryListModel} from "../../../models/survey/survey.model";
import {PreviousUrlService} from "../../../shared/services/previous-url.service";

@Component({
  selector: 'app-report-summary',
  templateUrl: './report-summary.component.html',
  styleUrls: ['./report-summary.component.less']
})
export class ReportSummaryComponent implements OnInit {

  navigation = ['Master Summary', 'Analyis', 'Report Summary', 'Payments'];

  dropdown = false;
  filter = false;
  people: Array<any>;
  column = 'gender';
  isDesc = false;
  surveyId: number;
  surveyTitle: string;
  loader: boolean = false;

  surveyReportSummaryPDModel: ReportSummaryListModel;

  constructor(private router: Router, private route: ActivatedRoute, private surveyService: SurveyService, private shareService: PreviousUrlService) {
    this.route.params.subscribe();
  }


  ngOnInit() {
    this.surveyId = parseInt(this.route.snapshot.paramMap.get('id'));
    this.surveyTitle = this.route.snapshot.paramMap.get('title');
    this.shareService.setSurveyTitle(this.surveyTitle);
    this.getMasterSummaryPDModel();
    this.people = [
      {
        id: 0,
        report: '',
        gender1: 'Female',
        gender2: 'Male',
        age1: '15 - 25',
        age2: '25 - 34',
        train1: 'Less than once a month',
        train2: 'A few times a month',
        train3: 'Never in my life, my god',
      },
      {
        id: 1,
        report: 'Female and 15 - 24 and 25 - 34',
        gender1: '66%',
        gender2: '34%',
        age1: '20%',
        age2: '45%',
        train1: '47',
        train2: '22',
        train3: '1299',
      },
    ];
  }

  sort(user) {
    this.isDesc = !this.isDesc;
    this.column = user;
    const direction = this.isDesc ? 1 : -1;

    this.people.sort(function (a, b) {
      if (a[user] < b[user]) {
        return -1 * direction;
      }
      else if (a[user] > b[user]) {
        return 1 * direction;
      }
      else {
        return 0;
      }
    });
  }

  toggleDropdown() {
    this.dropdown = !this.dropdown;
  }

  onClickOutside(event: Object) {
    if (event && event['value'] === true) {
      this.dropdown = false;
    }
  }

  getMasterSummaryPDModel() {
    this.loader = true;
    this.surveyService.getReportSummaryPDModel(this.surveyId)
      .subscribe((response) => {
          this.surveyReportSummaryPDModel = response;
          this.loader = false;
          for (const x of this.surveyReportSummaryPDModel.listSummary) {
            //x.listAnswerModel = this.surveyAnswerModel;
          }
        },
        (error) => {
          this.loader = false;
          // console.log(error);
        })
  }


  downloadAsCsv() {
    let headers = new Headers({
      'Content-Type': 'text/csv'
    });

    let data = '';

    // data = 'questionName' + ','.repeat(this.surveyMasterSummaryPDModel.listQuestionModel[0].listAnswerModel.length) + 'answerName,answerCount,answerPercentage\r\n';
    data += ',';

    for (let x of this.surveyReportSummaryPDModel.listSummary[0].listQuestion) {
        data += x.questionName.split(',').join(' ');
        if (x.listAnswer.length > 0) {
          data += ','.repeat(x.listAnswer.length);
        }
        else {
          data += ','.repeat(2);
        }
    }

    data += '\r\n';
    data += ',';

    for (let x of this.surveyReportSummaryPDModel.listSummary[0].listQuestion) {
        x.haveAnswered = 'Have Answered';
        x.haveNotAnswered = 'Have Not Answered';
        if (x.listAnswer.length > 0) {
          for (let y of x.listAnswer) {
            data += y.answerName.split(',').join(' ');
            data += ',';
          }
        }
        else {
          data += x.haveAnswered;
          data += ',' + x.haveNotAnswered + ',';
        }
    }

    data += '\r\n';

    for (let x of this.surveyReportSummaryPDModel.listSummary) {
      data += x.reportName;
      for (let item of x.listQuestion) {
        if (item.listAnswer.length > 0) {
          for (let y of item.listAnswer) {
            data += ',' + y.answerCount;
          }
        }
        else {
          data += ',' + item.answeredCount;
          data += ',' + item.nonAnsweredCount;
        }
      }
      data += '\r\n';

      for (let item of x.listQuestion) {
        if (item.listAnswer.length > 0) {
          for (let y of item.listAnswer) {
            data += ',' + y.answerPercentage;
          }
        }
        else {
          data += ',' + item.answeredPercentage;
          data += ',' + item.nonAnsweredPercentage;
        }
      }
      data += '\r\n';

    }

    // for (let x of this.surveyReportSummaryPDModel.listSummary) {
    //   for (let item of x.listQuestion) {
    //     if (item.listAnswer.length > 0) {
    //       for (let y of item.listAnswer) {
    //         data += ',' + y.answerPercentage + '%';
    //       }
    //       data += ',';
    //     }
    //     else {
    //       data += ',' + item.answeredPercentage + '%';
    //       data += ',' + item.nonAnsweredPercentage + '%';
    //     }
    //   }
    //   data += '\r\n';
    //   data += '\n';
    //
    // }

    // for (let x of this.surveyReportSummaryPDModel.listSummary) {
    //   for (let item of x.listQuestion) {
    //     if (item.listAnswer.length > 0) {
    //       for (let x of item.listAnswer) {
    //         data += ',' + x.answerPercentage + '%' + ',';
    //       }
    //     }
    //     else {
    //       data += ',' + item.answeredPercentage + '%' + ',';
    //       data += ',' + item.nonAnsweredPercentage + '%' + ',';
    //     }
    //   }
    // }
    this.downloadFile(data);
  }

  downloadFile(data) {
    let blob = new Blob(['\ufeff' + data], { type: 'attachment/csv' });
    let url = window.URL.createObjectURL(blob);

    if(navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, 'report.csv');
    } else {
        let a = document.createElement('a');
        a.href = url;
        a.download = 'report.csv';
        document.body.appendChild(a);
        a.click();        
        document.body.removeChild(a);
    }
    window.URL.revokeObjectURL(url);
  }
}



// WEBPACK FOOTER //
// ./src/app/routes/surveys/report-summary/report-summary.component.ts